import { List } from '@mui/material';
import type { ListOwnProps } from '@mui/material/List/List';

import type { MenuExtendedItem } from '@components/sidebar/types';

import { MenuItem } from './menuItem';

type MenuExtendedProps = {
  items: MenuExtendedItem[];
  isCollapsed: boolean;
  slots?: {
    list?: ListOwnProps;
  };
};

export const MenuExtended = (props: MenuExtendedProps) => {
  const { items, isCollapsed, slots = {} } = props;
  const { list } = slots;

  return (
    <List
      {...list}
      sx={{
        mt: 2,
        px: 1.25,
        gap: 1,
        display: 'flex',
        flexDirection: 'column',
        ...list?.sx,
      }}
    >
      {items.map((item, index) => {
        return (
          <MenuItem
            key={index}
            item={item}
            isCollapsed={isCollapsed}
          />
        );
      })}
    </List>
  );
};
